import { JobFairsVisual } from './JobFairsVisual'

export default JobFairsVisual
